window.setConfiguration = function(key, value, storage) {
  storage = storage || localStorage;
  let config = JSON.parse(storage.getItem("ishopfood-frontend-v3") || "{}");
  config[key] = value;
  storage.setItem("ishopfood-frontend-v3", JSON.stringify(config));
};

window.getConfiguration = function(key, storage) {
  storage = storage || localStorage;
  let config = JSON.parse(storage.getItem("ishopfood-frontend-v3") || "{}");
  return config[key];
};

window.padNumberWithLeadingZeros = function(length, number) {
  return String(number).padStart(length, "0");
};

window.showConfirmation = function(title, text, confirmText, cancelText, showIllustration, cssClass, bypassTimeout) {
  return new Promise(resolve => {
    window.displayAfterVisibleModalsAreClosed(() => {

      if (cssClass) {
        document.getElementById("modalConfirmation").classList.add(cssClass);
      }

      document.querySelector("#modalConfirmation .modal-header").innerHTML = title;
      document.querySelector("#modalConfirmation .modal-body .content").innerHTML = text;
      document.querySelector("#modalConfirmation .modal-yes").innerHTML = confirmText || translate("yes");
      document.querySelector("#modalConfirmation .modal-no").innerHTML = cancelText || translate("no");
      document.querySelector("#modalConfirmation .modal-yes").onclick = function() {
        resolve(true);
        document.getElementById("modalConfirmation").classList.remove("show");
        setTimeout(() => {
          document.getElementById("modalConfirmation").classList.remove(cssClass);
        }, 300);
      };
      document.querySelector("#modalConfirmation .modal-no").onclick = function() {
        resolve(false);
        document.getElementById("modalConfirmation").classList.remove("show");
        setTimeout(() => {
          document.getElementById("modalConfirmation").classList.remove(cssClass);
        }, 300);
      };
      for (let e of document.querySelectorAll("#modalConfirmation .illustration")) {
        e.classList.add("hidden");
      }
      if (showIllustration) {
        let element = document.querySelector("#modalConfirmation .illustration" + showIllustration);
        if (element) {
          element.classList.remove("hidden");
        }
      }
      document.getElementById("modalConfirmation").classList.add("show");

    }, bypassTimeout);
  });
};

window.showNumPad = function(title) {
  return new Promise(resolve => {
    let modal = document.getElementById("modalNumPad");
    let input = document.querySelector("#modalNumPad #txtNumPad");
    input.value = "";
    window.displayAfterVisibleModalsAreClosed(() => {
      document.querySelector("#modalNumPad .modal-header").innerHTML = title;
      document.querySelector("#modalNumPad .modal-yes").onclick = function() {
        if (!input.value) {
          return;
        }
        resolve(input.value);
        modal.classList.remove("show");
      };
      document.querySelector("#modalNumPad .modal-no").onclick = function() {
        resolve(false);
        modal.classList.remove("show");
      };
      for (let i = 0; i < 10; i++) {
        document.querySelector("#modalNumPad #btn-" + i).onclick = function() {
          input.value = input.value + i.toString();
        };
      }
      document.querySelector("#modalNumPad #btn-clear").onclick = function() {
        input.value = input.value.slice(0, -1);
      };

      modal.classList.add("show");
    });
  });
};

window.displayAfterVisibleModalsAreClosed = function(callback, override) {
  let interval = setInterval(() => {
    if (window.hasActiveModal()) {
      return;
    }
    clearInterval(interval);
    callback();
  }, override ? 0 : 500);
};

window.hasActiveModal = function() {
  let modalsActive = document.querySelectorAll(
    ".modal.show" +
    ":not(#orderOptionsModal)" +
    ":not(#quickAddModal)" +
    ":not(#modalImprovement)" +
    ":not(#modalUpdate)" +
    ":not(.modifierQuantityModal)" +
    ":not(#brandingSwitchWarningModal)" +
    ":not(#promoKeyboardModal)" +
    ":not(#promoModal)" +
    ":not(#brandingAboutModal)" +
    ":not(#ticketModal)" +
    ":not(#posDispatchModal)" +
    ":not(#authenticationModal)"
  );
  return modalsActive.length > 0;
};

/**
 * https://stackoverflow.com/questions/31259295/javascript-allow-only-specific-html-tags
 * Allow only specific HTML tags in input field
 * @param {String} input
 * @param {String} allowed
 * @return {String}
 */
window.stripTags = function(input, allowed) {
  allowed = (((allowed || "") + "")
    .toLowerCase()
    .match(/<[a-z][a-z0-9]*>/g) || [])
    .join(""); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
  let tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
  let commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
  return input.replace(commentsAndPhpTags, "")
    .replace(tags, function($0, $1) {
      return allowed.indexOf("<" + $1.toLowerCase() + ">") > -1 ? $0 : "";
    });
};

window.showAffirmation = function(title, text, buttonText, showIllustration, showSuccess, cssClass, bypassTimeout) {
  return new Promise(resolve => {
    window.displayAfterVisibleModalsAreClosed(() => {

      if (cssClass) {
        document.getElementById("modalAffirmation").classList.add(cssClass);
      }

      document.querySelector("#modalAffirmation .modal-header").innerHTML = title;
      document.querySelector("#modalAffirmation .modal-body .content").innerHTML = text;
      document.querySelector("#modalAffirmation .modal-ok").innerHTML = buttonText || translate("ok");
      document.querySelector("#modalAffirmation .modal-ok").onclick = function() {
        resolve();
        setTimeout(() => {
          document.getElementById("modalAffirmation").classList.remove("show");
        }, 300);
        setTimeout(() => {
          document.getElementById("modalAffirmation").classList.remove(cssClass);
        }, 600);
      };
      for (let e of document.querySelectorAll("#modalAffirmation .illustration")) {
        e.classList.add("hidden");
      }
      if (showIllustration) {
        let element = document.querySelector("#modalAffirmation .illustration" + showIllustration);
        if (element) {
          element.classList.remove("hidden");
        }
      }
      document.querySelector("#modalAffirmation .success").classList.add("hidden");
      document.querySelector("#modalAffirmation .modal-header").style.paddingLeft = "";
      if (showSuccess) {
        let element = document.querySelector("#modalAffirmation .success");
        let header = document.querySelector("#modalAffirmation .modal-header");
        if (element) {
          element.classList.remove("hidden");
          if (header) {
            header.style.paddingLeft = "15px";
          }
        }
      }
      document.getElementById("modalAffirmation").classList.add("show");

    }, bypassTimeout);
  });
};

window.showForceUpdate = function(title, text, buttonText, url) {
  document.querySelector("#modalUpdate .modal-header").innerHTML = title;
  document.querySelector("#modalUpdate .modal-body .content").innerHTML = text;
  if (!url) {
    document.querySelector("#modalUpdate .modal-update").style.display = "none";
  } else {
    document.querySelector("#modalUpdate .modal-update").innerHTML = buttonText || translate("update");
    document.querySelector("#modalUpdate .modal-update").onclick = function() {
      window.openExternalWebsite(url, "_system");
    };
  }
  document.querySelector("#modalUpdate .modal-header").style.paddingLeft = "";
  document.getElementById("modalUpdate").classList.add("show");
};

window.showOneTimeAffirmation = function(title, text) {
  let str = JSON.stringify(text);
  let shown = getConfiguration("showed-affirmations") || [];
  for (let show of shown) {
    if (show == str) {
      return;
    }
  }
  shown.push(str);
  setConfiguration("showed-affirmations", shown);
  return showAffirmation(title, translateObject(text));
};

// https://stackoverflow.com/questions/20712419/get-utc-offset-from-timezone-in-javascript
window.getTimezoneOffset = (timeZone, date = new Date()) => {
  const tz = date.toLocaleString("en", { timeZone, timeStyle: "long" }).split(" ").slice(-1)[0];
  const dateString = date.toString();
  const offset = Date.parse(`${dateString} UTC`) - Date.parse(`${dateString} ${tz}`);

  return offset / (60 * 1000);
};

window.wait = function(millis) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, millis);
  });
};

window.scrollToError = function() {
  setTimeout(() => {
    document.getElementsByClassName("error-box visible")[0].scrollIntoView({ behavior: "smooth" });
  }, 100);
};

window.scrollToEndOfCart = function() {
  setTimeout(() => {
    let items = document.getElementById("cartItemList").getElementsByClassName("cart-item");
    if (items.length === 0) {
      items = document.getElementById("cartItemList").getElementsByClassName("compact-cart-item");
    }
    if (items.length === 0) {
      items = document.getElementById("cartItemList").getElementsByClassName("pos-cart-item");
    }
    if (items.length > 0) {
      items[items.length - 1].scrollIntoView({ behavior: "smooth" });
    }
  }, 50);
};

let spinnerStack = 0;
window.showSpinner = function(text) {
  let spinner = document.getElementById("spinner");
  if (spinner) {
    if (spinnerStack == 0) {
      spinner.classList.add("show");
    }
    if (text) {
      spinner.getElementsByClassName("text")[0].classList.remove("hidden");
      spinner.getElementsByClassName("text")[0].innerHTML = text;
    } else {
      spinner.getElementsByClassName("text")[0].classList.add("hidden");
    }
  }
  spinnerStack++;
};
window.hideSpinner = function(force) {
  if (spinnerStack > 0) {
    spinnerStack--;
  }
  if ((spinnerStack === 0 || force) && document.getElementById("spinner")) {
    document.getElementById("spinner").classList.remove("show");
    if (force) {
      spinnerStack = 0;
    }
  }
};

/**
 * @param {{type: String, url: String, attributes: []?}} data
 * @returns {Promise}
 */
window.loadScript = async (data) => {
  let id = data.url;
  if (document.querySelectorAll(`[id="${id}"]`).length > 0) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    if (data.type === "javascript") {
      let script = document.createElement("script");
      script.setAttribute("id", id);
      script.setAttribute("type", "text/javascript");
      script.setAttribute("src", data.url);
      if (data.attributes && Array.isArray(data.attributes)) {
        for (let attribute of data.attributes) {
          script.setAttribute(attribute.name, attribute.value);
        }
      }
      document.body.appendChild(script);
      script.onload = () => { resolve(); };
    } else {
      let stylesheet = document.createElement("link");
      stylesheet.setAttribute("id", id);
      stylesheet.setAttribute("href", data.url);
      stylesheet.setAttribute("type", "text/css");
      stylesheet.setAttribute("rel", "stylesheet");
      document.body.appendChild(stylesheet);
      stylesheet.onload = () => { resolve(); };
    }
  });
};

/**
 * @param {{type: String, active: boolean, url: String}[]} scripts
 * @returns {Promise}
 */
window.loadScripts = async (scripts) => {
  for (let script of scripts) {
    if (!script.active) {
      continue;
    }
    await window.loadScript(script);
  }
};

window.request = function(method, url, data, plain) {

  let _formatParameter = function(key, value) {
    if (!value) {
      return "";
    }
    if (typeof value === "object") {
      if (typeof value.length !== "undefined") {
        return _formatArrayParameter(key, value);
      }
      return _formatObjectParameter(key, value);
    }
    return key + "=" + value;
  };

  let _formatArrayParameter = function(key, values) {
    let str = "";
    for (let i = 0; i < values.length; i++) {
      let param = _formatParameter(key + "[" + i + "]", values[i]);
      if (param) {
        str += param + "&";
      }
    }
    return str.substring(0, str.length - 1);
  };

  let _formatObjectParameter = function(key, obj) {
    let str = "";
    for (let objKey of Object.keys(obj)) {
      let param;
      if (key) {
        param = _formatParameter(key + "[" + objKey + "]", obj[objKey]);
      } else {
        param = _formatParameter(objKey, obj[objKey]);
      }
      if (param) {
        str += param + "&";
      }
    }
    return str.substring(0, str.length - 1);
  };

  return new Promise((resolve, reject) => {
    let request = new XMLHttpRequest();
    if (data && method == "GET") {
      url += "?" + _formatObjectParameter(null, data);
      data = null;
    }
    request.open(method, url, true);
    request.onload = () => {
      if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
        if (request.responseText) {
          try {
            let parsed = JSON.parse(request.responseText);
            resolve(parsed);
          } catch (e) {
            resolve(request.responseText);
          }
        } else {
          resolve(null);
        }
      } else {
        if (request.status === 426 && !!store.state.mobileOs) {
          let parsedResponse = request.responseText ? JSON.parse(request.responseText) : null;
          if (!!parsedResponse && !!parsedResponse[store.state.mobileOs]) {
            store.state.updateUrl = parsedResponse[store.state.mobileOs].url;
          }
          store.state.updateRequired = true;
        }
        reject(request);
      }
    };
    request.onerror = () => {
      reject(request);
    };
    if (!plain) {
      if (store.state.user && store.state.user.token) {
        request.setRequestHeader("Authorization", "Bearer " + store.state.user.token);
      } else if (CONFIG.kiosk && getConfiguration("kiosk-api-key")) {
        request.setRequestHeader("api-key", getConfiguration("kiosk-api-key"));
      }
    }
    if (data) {
      request.setRequestHeader("Content-Type", "application/json");
    }
    if (typeof cordova !== "undefined") {
      request.setRequestHeader("User-App-Name", CONFIG.shopLock);
      if (store.state.mobileOs === "android" && typeof CONFIG.versionAndroid !== "undefined") {
        request.setRequestHeader("User-Version-Android", CONFIG.versionAndroid);
      } else if (store.state.mobileOs === "ios" && typeof CONFIG.versionIos !== "undefined") {
        request.setRequestHeader("User-Version-IOS", CONFIG.versionIos);
      }
    }

    request.send(data ? JSON.stringify(data) : null);
  });

};

window.getNavigator = function() {
  var ua = navigator.userAgent; var tem; var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: "IE", version: (tem[1] || "") };
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) { return { name: "Opera", version: tem[1] }; }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
  return {
    name: M[0],
    version: M[1]
  };
};

window.parseHour = function(text) {
  let split = text.split(":");
  let hour = {
    hour: parseInt(split[0]),
    minute: parseInt(split[1])
  };
  hour.toString = function() {
    return this.hour + ":" + (this.minute < 9 ? "0" : "") + this.minute;
  };
  hour.isAfter = function(hour) {
    if (this.hour > hour.hour) {
      return true;
    }
    if (this.hour == hour.hour && this.minute > hour.minute) {
      return true;
    }
    return false;
  };
  return hour;
};

/**
 * @return {boolean}
 */
window.isExecutable = function() {
  return typeof nw !== "undefined";
};

const SCROLL_OFFSET = 15;
/**
 * @param {HTMLElement} element
 * @return {boolean}
 */
window.isElementAtBeginningOfVerticalScroll = function(element) {
  return element.scrollTop <= SCROLL_OFFSET;
};

/**
 * @param {HTMLElement} element
 * @return {boolean}
 */
window.isElementAtBeginningOfHorizontalScroll = function(element) {
  return element.scrollLeft <= SCROLL_OFFSET;
};

/**
 * @param {any} message
 * @param {string?} prefix
 */
window.logToFile = async function(message, prefix) {
  if (!window.isExecutable()) {
    return;
  }
  let fs = nw.require("fs");
  let now = new Date();
  let timestamp = "[" + now.toLocaleString() + "] ";
  let prefixStr = "";
  if (prefix) {
    prefixStr = "[" + prefix + "] ";
  }
  let today = now.toISOString().slice(0, 10) + "_" + now.getHours();
  let path = "./logs/" + today + ".log";
  let fileHandle = null;

  if (typeof message !== "string") {
    message = JSON.stringify(message);
  }
  message = timestamp + prefixStr + message + "\r\n";

  try {
    fileHandle = await fs.promises.open(path, "a");
    await fileHandle.appendFile(message, "utf8");
  } catch (e) {
    if (e) {
      console.log("FILE LOG ERROR", e);
    }
    if (fileHandle) {
      await fileHandle.close();
    }
  }
  if (fileHandle) {
    await fileHandle.close();
  }
};

/**
 * @param {HTMLElement} element
 * @return {boolean}
 */
window.isElementAtEndOfVerticalScroll = function(element) {
  return ((Math.round(element.scrollTop) + element.offsetHeight + SCROLL_OFFSET) >= element.scrollHeight) ||
          ((element.clientHeight + SCROLL_OFFSET) >= element.scrollHeight);
};

/**
 * @param {HTMLElement} element
 * @return {boolean}
 */
window.isElementAtEndOfHorizontalScroll = function(element) {
  return ((Math.round(element.scrollLeft) + element.offsetWidth + SCROLL_OFFSET) >= element.scrollWidth) ||
    ((element.clientWidth + SCROLL_OFFSET) >= element.scrollWidth);
};

window.generateUUID = function() {
  let chars = [];
  for (let i = 48; i <= 57; i++) {
    chars.push(i);
  }
  for (let i = 65; i <= 90; i++) {
    chars.push(i);
  }
  for (let i = 97; i <= 122; i++) {
    chars.push(i);
  }
  let uuid = "";
  for (let i = 0; i < 32; i++) {
    uuid += String.fromCharCode(chars[Math.floor(Math.random() * chars.length)]);
  }
  return uuid;
};

window.getGoogle = function() {
  return new Promise((resolve, reject) => {
    if (typeof google !== "undefined") {
      resolve(google);
    }
    let interval = setInterval(() => {
      if (typeof google !== "undefined") {
        resolve(google);
        clearInterval(interval);
      }
    }, 100);
  });
};

window.openExternalWebsite = function(url, target = (typeof cordova !== "undefined" ? "_blank" : "_system"), options = "location=no,usewkwebview=yes,toolbar=yes") {
  if (typeof cordova !== "undefined" && typeof device !== "undefined" && device.platform == "Android") {
    cordova.InAppBrowser.open(url, target, "location=yes,usewkwebview=yes,toolbar=no");
  } else if (typeof cordova !== "undefined") {
    cordova.InAppBrowser.open(url, target, options);
  } else {
    window.open(url, target);
  }
};

window.getBase64Data = function(url) {
  return url.replace(/^data:image\/(png|jpeg|gif);base64,/, "");
};

/*
 * Flight distance
 * @param latitude1
 * @param longitude1
 * @param latitude2
 * @param longitude2
 * @return {number}
 */
window.calculateDistance = function(latitude1, longitude1, latitude2, longitude2) {

  if ((!latitude1 && !longitude1) || (!latitude2 && !longitude2)) {
    return 0;
  }

  let R = 6371; // km
  let dLat = toRad(latitude2 - latitude1);
  let dLon = toRad(longitude2 - longitude1);
  let lat1 = toRad(latitude1);
  let lat2 = toRad(latitude2);

  let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c;

  return d;
};

function toRad(Value) {
  return Value * Math.PI / 180;
}

/**
 * Convert ISO 2 country to ISO 3 country
 * @param {String} countryISO2 (2-alpha ISO)
 * @return {String} country (3-alpha ISO)
 */
window.getCountryISO3 = function(countryISO2) {
  let countryISOMapping = { AF: "AFG", AX: "ALA", AL: "ALB", DZ: "DZA", AS: "ASM", AD: "AND", AO: "AGO", AI: "AIA", AQ: "ATA", AG: "ATG", AR: "ARG", AM: "ARM", AW: "ABW", AU: "AUS", AT: "AUT", AZ: "AZE", BS: "BHS", BH: "BHR", BD: "BGD", BB: "BRB", BY: "BLR", BE: "BEL", BZ: "BLZ", BJ: "BEN", BM: "BMU", BT: "BTN", BO: "BOL", BA: "BIH", BW: "BWA", BV: "BVT", BR: "BRA", VG: "VGB", IO: "IOT", BN: "BRN", BG: "BGR", BF: "BFA", BI: "BDI", KH: "KHM", CM: "CMR", CA: "CAN", CV: "CPV", KY: "CYM", CF: "CAF", TD: "TCD", CL: "CHL", CN: "CHN", HK: "HKG", MO: "MAC", CX: "CXR", CC: "CCK", CO: "COL", KM: "COM", CG: "COG", CD: "COD", CK: "COK", CR: "CRI", CI: "CIV", HR: "HRV", CU: "CUB", CY: "CYP", CZ: "CZE", DK: "DNK", DJ: "DJI", DM: "DMA", DO: "DOM", EC: "ECU", EG: "EGY", SV: "SLV", GQ: "GNQ", ER: "ERI", EE: "EST", ET: "ETH", FK: "FLK", FO: "FRO", FJ: "FJI", FI: "FIN", FR: "FRA", GF: "GUF", PF: "PYF", TF: "ATF", GA: "GAB", GM: "GMB", GE: "GEO", DE: "DEU", GH: "GHA", GI: "GIB", GR: "GRC", GL: "GRL", GD: "GRD", GP: "GLP", GU: "GUM", GT: "GTM", GG: "GGY", GN: "GIN", GW: "GNB", GY: "GUY", HT: "HTI", HM: "HMD", VA: "VAT", HN: "HND", HU: "HUN", IS: "ISL", IN: "IND", ID: "IDN", IR: "IRN", IQ: "IRQ", IE: "IRL", IM: "IMN", IL: "ISR", IT: "ITA", JM: "JAM", JP: "JPN", JE: "JEY", JO: "JOR", KZ: "KAZ", KE: "KEN", KI: "KIR", KP: "PRK", KR: "KOR", KW: "KWT", KG: "KGZ", LA: "LAO", LV: "LVA", LB: "LBN", LS: "LSO", LR: "LBR", LY: "LBY", LI: "LIE", LT: "LTU", LU: "LUX", MK: "MKD", MG: "MDG", MW: "MWI", MY: "MYS", MV: "MDV", ML: "MLI", MT: "MLT", MH: "MHL", MQ: "MTQ", MR: "MRT", MU: "MUS", YT: "MYT", MX: "MEX", FM: "FSM", MD: "MDA", MC: "MCO", MN: "MNG", ME: "MNE", MS: "MSR", MA: "MAR", MZ: "MOZ", MM: "MMR", NA: "NAM", NR: "NRU", NP: "NPL", NL: "NLD", AN: "ANT", NC: "NCL", NZ: "NZL", NI: "NIC", NE: "NER", NG: "NGA", NU: "NIU", NF: "NFK", MP: "MNP", NO: "NOR", OM: "OMN", PK: "PAK", PW: "PLW", PS: "PSE", PA: "PAN", PG: "PNG", PY: "PRY", PE: "PER", PH: "PHL", PN: "PCN", PL: "POL", PT: "PRT", PR: "PRI", QA: "QAT", RE: "REU", RO: "ROU", RU: "RUS", RW: "RWA", BL: "BLM", SH: "SHN", KN: "KNA", LC: "LCA", MF: "MAF", PM: "SPM", VC: "VCT", WS: "WSM", SM: "SMR", ST: "STP", SA: "SAU", SN: "SEN", RS: "SRB", SC: "SYC", SL: "SLE", SG: "SGP", SK: "SVK", SI: "SVN", SB: "SLB", SO: "SOM", ZA: "ZAF", GS: "SGS", SS: "SSD", ES: "ESP", LK: "LKA", SD: "SDN", SR: "SUR", SJ: "SJM", SZ: "SWZ", SE: "SWE", CH: "CHE", SY: "SYR", TW: "TWN", TJ: "TJK", TZ: "TZA", TH: "THA", TL: "TLS", TG: "TGO", TK: "TKL", TO: "TON", TT: "TTO", TN: "TUN", TR: "TUR", TM: "TKM", TC: "TCA", TV: "TUV", UG: "UGA", UA: "UKR", AE: "ARE", GB: "GBR", US: "USA", UM: "UMI", UY: "URY", UZ: "UZB", VU: "VUT", VE: "VEN", VN: "VNM", VI: "VIR", WF: "WLF", EH: "ESH", YE: "YEM", ZM: "ZMB", ZW: "ZWE", XK: "XKX" };
  return countryISOMapping[countryISO2];
};

window.getTodayStringDate = function() {
  let today = new Date();
  return today.getFullYear() + "/" + (today.getMonth() + 1) + "/" + today.getDate();
};

window.spaceBetweenPad = function(startString = "", length, pad, endString = "") {
  return rightPad(startString, length - endString.length, pad) + endString;
};

window.spaceAroundPad = function(string = "", length, pad) {
  let left = leftPad(string, string.length + Math.floor((length - string.length) / 2), pad);
  return rightPad(left, length, pad);
};

window.leftPad = function(string, length, pad) {
  string = String(string);
  pad = pad || "0";
  while (string.length < length) {
    string = pad + string;
  }
  return string;
};

window.rightPad = function(str, length, padding) {
  str = String(str);
  while (str.length < length) {
    str += padding;
  }
  return str;
};

/**
 * https://stackoverflow.com/questions/3733227/javascript-seconds-to-minutes-and-seconds
 * @param {number} num
 * @returns {string}
 */
window.secondsToTime = function(num) {
  let hours = Math.floor(num / 3600).toString().padStart(2, "0");
  let minutes = Math.floor(num % 3600 / 60).toString().padStart(2, "0");
  let seconds = Math.floor(num % 60).toString().padStart(2, "0");

  return hours + ":" + minutes + ":" + seconds;
};

/* Constants */

window.DEMO_TABLE = "qr-payment-demo";
window.DEFAULT_POS_STANDBY_SCREEN_URL = "https://ishopfood.s3-us-west-2.amazonaws.com/default/5514dbccd3346e43515832708cc844359189e809.jpeg";
window.DEFAULT_POS_ORDERING_BANNER_URL = "https://ishopfood.s3-us-west-2.amazonaws.com/default/302fbe26eb5e1736c5f51ae97b5fd4aeca27ffe1.jpeg";
